import { Center, Flex, Text } from "@mantine/core";
import { ReactElement, ReactNode } from "react";
import { Link } from "react-router";

type AppMenuLinkProps = {
  icon: ReactNode;
  label: string;
  link: string;
  className?: string;
  onClick?: () => void;
  showLabel?: boolean;
  badge?: ReactElement;
};

export const AppMenuLink: React.FC<AppMenuLinkProps> = ({
  showLabel = true,
  icon,
  label,
  link,
  className,
  onClick,
  badge,
}) => {
  return (
    <Flex
      className={className}
      to={link}
      component={Link}
      gap={4}
      align={"center"}
      onClick={onClick}
    >
      <div className="relative">
        {icon}

        {!showLabel && badge && (
          <div className="absolute top-0 right-0 transform translate-x-2/5 -translate-y-2/5 pointer-events-none">
            {badge}
          </div>
        )}
      </div>

      {showLabel && <Text lineClamp={1}>{label}</Text>}

      {showLabel && badge && <Center>{badge}</Center>}
    </Flex>
  );
};
